export default __webpack_public_path__ + "static/media/spin1.86646140.gif";